import {
  agencyLogin,
  DoctorLogin,
  PatientLogin,
} from "../api/helper";

import { Store } from "../redux";
import { setHeaderToken, setUserDetails } from "../redux/cookiesReducer";
import { setOwnProfile, setUserProfile } from "../redux/reducer";
import { ShowToast } from "./ToastService";

const web = "web";

export const userLoginProcess = async (state, onSuccessCallback) => {
  const data = Store.getState();

  const param = {
    email: state?.email,
    password: state?.password,
    device_id: "web",
    device_token: state.deviceToken ? state.deviceToken : "no",
  };

  try {
    let response = {};

    if (data.cookies.loginType === "Doctor") {
      response = await DoctorLogin(param);
    } else if (data.cookies.loginType === "Clinic") {
      response = await agencyLogin(param);
    } else if (data.cookies.loginType === "Patient") {
      response = await PatientLogin(param);
    }

    if (response.data?.success) {
      const user = response?.data?.data?.user;
      const userRole = user?.role;

      if (web) {
        Store.dispatch(setUserDetails(user));
        Store.dispatch(setHeaderToken(user));
        ShowToast(response?.data?.message, "success");

        // Call the callback to let component handle navigation
        if (onSuccessCallback && typeof onSuccessCallback === "function") {
          onSuccessCallback(userRole);
        }
      }
    } else {
      ShowToast(response.error || "Login failed", "error");
    }
  } catch (error) {
    console.error("Login error:", error);
    ShowToast("Something went wrong during login", "error");
  }
};



export const clearEmptyData = (data) => {
  if (Array.isArray(data)) {
    return data
      .map(clearEmptyData)
      .filter(item => item !== null && item !== undefined &&
        !(Array.isArray(item) && item.length === 0) &&
        !(typeof item === 'object' && Object.keys(item).length === 0) &&
        item !== '');
  } else if (typeof data === 'object' && data !== null) {
    return Object.entries(data).reduce((acc, [key, value]) => {
      const cleanedValue = clearEmptyData(value);
      if (cleanedValue !== null && cleanedValue !== undefined &&
        !(Array.isArray(cleanedValue) && cleanedValue.length === 0) &&
        !(typeof cleanedValue === 'object' && Object.keys(cleanedValue).length === 0) &&
        cleanedValue !== '') {
        acc[key] = cleanedValue;
      }
      return acc;
    }, {});
  }
  return data;
};
